// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options) {
    return request('/api/backstage/currentUser', {
        method: 'GET',
        ...(options || {}),
    });
}
/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options) {
    return request('/api/backstage/login/outLogin', {
        method: 'POST',
        ...(options || {}),
    });
}
/** 登录接口 POST /api/login/account */
export async function login(body, options) {
    return request('/api/backstage/login/account', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    });
}
/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options) {
    return request('/api/notices', {
        method: 'GET',
        ...(options || {}),
    });
}
/** 获取规则列表 GET /api/rule */
export async function rule(params, options) {
    return request('/api/rule', {
        method: 'GET',
        params: {
            ...params,
        },
        ...(options || {}),
    });
}
/** 更新规则 PUT /api/rule */
export async function updateRule(options) {
    return request('/api/rule', {
        method: 'POST',
        data: {
            method: 'update',
            ...(options || {}),
        },
    });
}
/** 新建规则 POST /api/rule */
export async function addRule(options) {
    return request('/api/rule', {
        method: 'POST',
        data: {
            method: 'post',
            ...(options || {}),
        },
    });
}
/** 删除规则 DELETE /api/rule */
export async function removeRule(options) {
    return request('/api/rule', {
        method: 'POST',
        data: {
            method: 'delete',
            ...(options || {}),
        },
    });
}
